import "./base.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotPickerModal ??= {};
window.AppointmentBooking.SlotPickerModal.Views ??= {};

AppointmentBooking.SlotPickerModal.Views.BaseTabView = class BaseTabView extends (
  AppointmentBooking.SlotPickerModal.Views.Base
) {
  constructor() {
    super(...arguments);
    this.contextForRender = this.contextForRender.bind(this);
    this.getSchedulingOptions = this.getSchedulingOptions.bind(this);
  }

  contextForRender() {
    const context = super.contextForRender();
    context.appointmentGridDates = this.appointmentGridDates.toJSON();
    context.schedulingOptions = this.getSchedulingOptions();
    return context;
  }

  getSchedulingOptions() {
    const selectedAddress = this.model.get("resource").get("selected_address");
    return (
      (selectedAddress != null
        ? selectedAddress.scheduling[`${this.model.get("filters").get("patient_type")}_patient`]
        : undefined) || {}
    );
  }
};
AppointmentBooking.SlotPickerModal.Views.BaseTabView.prototype.tagName = "div";
